// Material Dashboard 2 React components
import MDBox from "components/MDBox"
// Tipos de asistente page components
import TipoAsistenteItem from "layouts/asistencia/tipos-asistente/components/TipoAsistenteItem"
import PropTypes from "prop-types"

function TiposAsistenteInformation({ tiposAsistente, onReload }) {
  return (
    <MDBox pt={1} pb={2} px={2}>
      {tiposAsistente?.map((item) => (
        <div key={item.id}>
          <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
            <TipoAsistenteItem
              key={item.id}
              id={item.id}
              nombre={item.nombre}
              dependenciaNombre={item.dependenciaNombre}
              onReload={onReload}
            />
          </MDBox>
          <hr></hr>
        </div>
      ))}
    </MDBox>
  )
}

TiposAsistenteInformation.propTypes = {
  tiposAsistente: PropTypes.arrayOf(PropTypes.object).isRequired,
  onReload: PropTypes.func.isRequired,
}

export default TiposAsistenteInformation
